import { Users } from 'src/api';

export interface AppInterface {
  host: string;
  isUndefinedServerError: boolean;
  user: Users.Types.User | null;
  isLeftDrawerOpen: boolean;
  pageTitle: string;
}

export default function (): AppInterface {
  return {
    host: '',
    isUndefinedServerError: false,
    user: null,
    isLeftDrawerOpen: false,
    pageTitle: '',
  };
}
